var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VFlex',{class:['display-only', { 'print-mode': _vm.isPrintModeOn }]},[_c('span',[_vm._v(_vm._s(_vm.value))]),(_vm.hint.length && ['sm', 'xs'].includes(_vm.$mq))?_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }